import {
  deserializeDevalue as deserializeDevalueInternal,
  serializeDevalue as serializeDevalueInternal,
} from '@sweetistics/trpc-shared';
import { QueryClient } from '@tanstack/react-query';
import { TIMEOUTS } from '@/constants/timeouts';

function applyDomainQueryDefaults(queryClient: QueryClient) {
  queryClient.setQueryDefaults(['timeline'], {
    staleTime: TIMEOUTS.CACHE.STALE.MEDIUM,
    gcTime: TIMEOUTS.CACHE.GC.LONG,
  });
  queryClient.setQueryDefaults(['mentions'], {
    staleTime: TIMEOUTS.CACHE.STALE.MEDIUM,
    gcTime: TIMEOUTS.CACHE.GC.LONG,
  });
  queryClient.setQueryDefaults(['timelineInsights'], {
    staleTime: TIMEOUTS.CACHE.STALE.STANDARD,
    gcTime: TIMEOUTS.CACHE.GC.LONG,
  });
  queryClient.setQueryDefaults(['timelineInsightsInfinite'], {
    staleTime: TIMEOUTS.CACHE.STALE.STANDARD,
    gcTime: TIMEOUTS.CACHE.GC.LONG,
  });
  queryClient.setQueryDefaults(['explore'], {
    staleTime: TIMEOUTS.CACHE.STALE.LONG,
    gcTime: TIMEOUTS.CACHE.GC.LONG,
  });
  queryClient.setQueryDefaults(['friendimizer'], {
    staleTime: TIMEOUTS.CACHE.STALE.MEDIUM,
    gcTime: TIMEOUTS.CACHE.GC.LONG,
  });
  queryClient.setQueryDefaults(['archive'], {
    staleTime: TIMEOUTS.CACHE.STALE.MEDIUM,
    gcTime: TIMEOUTS.CACHE.GC.LONG,
  });
  queryClient.setQueryDefaults(['arena'], {
    staleTime: TIMEOUTS.CACHE.STALE.MEDIUM,
    gcTime: TIMEOUTS.CACHE.GC.LONG,
  });
  queryClient.setQueryDefaults(['pulse'], {
    staleTime: TIMEOUTS.CACHE.STALE.FAST,
    gcTime: TIMEOUTS.CACHE.GC.MEDIUM,
  });
}

export function createQueryClient(): QueryClient {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: TIMEOUTS.CACHE.STALE.STANDARD,
        gcTime: TIMEOUTS.CACHE.GC.MEDIUM,
        // Retry failed requests 3 times
        retry: 3,
        // Retry delay increases exponentially
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30_000),
        // Avoid refetching heavy queries on focus unless explicitly enabled.
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
      },
    },
  });

  applyDomainQueryDefaults(queryClient);
  return queryClient;
}

export function deserializeDehydratedState(...parameters: Parameters<typeof deserializeDevalueInternal>) {
  return deserializeDevalueInternal(...parameters);
}

export function serializeDehydratedState(...parameters: Parameters<typeof serializeDevalueInternal>) {
  return serializeDevalueInternal(...parameters);
}
